(() => {
  'use strict';
  if (window.__uniWhatsappLoaded) return;
  window.__uniWhatsappLoaded = true;
  let queued = false;
  const intersectsViewport = (element) => {
    if (!element || element.hidden || element.closest('[hidden]')) return false;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  };
  const anyVisible = (selector) => [...document.querySelectorAll(selector)].some(intersectsViewport);
  const update = () => {
    queued = false;
    const control = document.querySelector('[data-whatsapp-float]');
    if (!control) return;
    control.classList.add('uni-whatsapp--floating');
    document.querySelector('[data-whatsapp-reserve]')?.setAttribute('data-whatsapp-reserved', '');
    const menuOpen = document.body.classList.contains('uni-menu-is-open') || anyVisible('#UniMobileMenu:not([hidden]), [data-menu-panel]:not([hidden])') || Boolean(document.querySelector('[data-menu-toggle][aria-expanded="true"]'));
    const blockingOverlay = anyVisible('[data-consent]:not([hidden]), dialog[open], [role="dialog"][aria-modal="true"]');
    const formVisible = anyVisible('[data-uni-contact-form], [data-uni-pqr][open] [data-uni-pqr-form]');
    const editableFocused = document.activeElement?.matches('input:not([type="hidden"]),textarea,select,[contenteditable="true"]');
    const keyboardActive = window.innerWidth < 900 && editableFocused;
    let obstruction = 0;
    document.querySelectorAll('[data-program-sticky], [data-compare-tray], [data-mobile-bottom-nav], #shop-hcaptcha-badge-container').forEach((bar) => {
      if (!intersectsViewport(bar)) return;
      const position = getComputedStyle(bar).position;
      if (position !== 'fixed' && position !== 'sticky') return;
      const rect = bar.getBoundingClientRect();
      if (rect.bottom >= window.innerHeight - 96) obstruction = Math.max(obstruction, window.innerHeight - rect.top);
    });
    const header = document.querySelector('[data-header]');
    const topBoundary = intersectsViewport(header) ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const notEnoughRoom = window.innerHeight - obstruction - 94 < topBoundary + 64;
    control.style.setProperty('--uni-whatsapp-obstruction', `${Math.ceil(obstruction)}px`);
    control.hidden = Boolean(menuOpen || blockingOverlay || formVisible || keyboardActive || notEnoughRoom);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  const observe = () => {
    if ('MutationObserver' in window) {
      new MutationObserver((records) => {
        if (records.some((record) => !record.target.closest?.('[data-whatsapp-float], [data-whatsapp-reserve]'))) schedule();
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open', 'aria-expanded', 'aria-hidden', 'class'] });
    }
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
